import React from 'react';

interface SantaClausWrapperProps {
  children: React.ReactNode;
}

export const SantaClausWrapper: React.FC<SantaClausWrapperProps> = ({ children }) => {
  return <div className="px-[15px] lg:px-8.375 py-8 md:pt-[54px] md:pb-[50px]">{children}</div>;
};
